module.exports = __webpack_public_path__ + "img/background_01.f7484eaa.jpg";